import { Button, LinearProgress, Grid, Box, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import withServices from '../../hocs/withServices';
import { useAlert } from '../../hooks/useAlert';
import grantPermission from '../../helpers/grantPermission';

function FileUpload({
  services,
  helperText,
  fileType,
  file,
  filePath,
  handleSetFileId,
  handleDelete,
  userId,
  disabled
}) {
  const [progress, setProgress] = useState(0);
  const showAlert = useAlert();


  const handleSecretaryFileDownload = () => {
    services.fileUpload.getDocumentSecretary(
      userId,
      file,
      filePath.split("/").pop()
    );
  }
  const handleFileChange = event => {
    const [file] = event.target.files;
    const callback = progress => {
      setProgress(progress === 100 ? 0 : progress);
    };
    services.fileUpload.secretaryUploadAbiturDocument(file, userId, fileType, callback)
      .then(response => {
        showAlert('Успешно загружен! Не забудьте нажать кнопку "сохранить"', 'success')
        handleSetFileId(response.data);
      })
      .catch(error => {
        showAlert(error.response.data.message, 'error')
      })
      .finally(() => event.target.value = null);
  };

  const deleteFile = () => {
    services.fileUpload.deleteFile(file, userId)
      .then(response => {
        showAlert('Успешно удален!', 'success')
      })
      .catch(error => {
        showAlert(error.response.data.message, 'error')
      })
      .finally(() => {
        handleDelete()
      })
  }

  return (
    <Grid container spacing={2}>
      {file && filePath && (
        <Grid item xs={12}>
          <Grid container justify="center">
            <Button
              variant="contained"
              color="primary"
              onClick={handleSecretaryFileDownload}
              fullWidth
            >
              Скачать ранее загруженный документ ({helperText})
            </Button>
          </Grid>
          {disabled && (
            <Grid container justify="center" style={{ marginTop: 20 }}>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => deleteFile()}
                fullWidth
              >
                Удалить файл
              </Button>
            </Grid>
          )}
        </Grid>
      )}
      {progress > 0 && (
        <Grid item xs={12}>
          <Box display="flex" alignItems="center">
            <Box width="100%" mr={1}>
              <LinearProgress variant="determinate" value={progress} />
            </Box>
            <Box minWidth={35}>
              <Typography variant="body2" color="textSecondary">
                {Math.round(progress)}%
              </Typography>
            </Box>
          </Box>
        </Grid>
      )}
      {disabled && (
        <Grid item xs={12}>
          <Button
            variant='outlined'
            component="label"
            fullWidth
          >
            {file && filePath ? `Обновить ${helperText}` : `Загрузить ${helperText}`}
            <input
              type="file"
              hidden
              onChange={event => handleFileChange(event)}
            />
          </Button>
        </Grid>
      )}
    </Grid>
  );
}

FileUpload.defaultProps = {
  disabled: grantPermission('ROLE_DORMITORY') ? false : true
}

export default withServices()(FileUpload);